import { toast } from "sonner";

export function showToastSuccess(message) {
    toast.success(message, {
            style: {
                background: "#4caf50",
                color: "#ffffff",
                border: "none",
            }
        }
    );
}

export function showToastError(message) {
    toast.error(message, {
            style: {
                background: "#f44336",
                color: "#ffffff",
                border: "none",
            }
        }
    );
}